import { render } from "./EnbClients.vue?vue&type=template&id=5bd675e8&scoped=true"
import script from "./EnbClients.vue?vue&type=script&lang=js"
export * from "./EnbClients.vue?vue&type=script&lang=js"

import "./EnbClients.vue?vue&type=style&index=0&id=5bd675e8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bd675e8"]])

export default __exports__